/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Api from '@/api';
/* eslint-enable import/no-cycle */
import Util from '@/util';

const theState = {
    errorMessage: '',
    infoMessage: '',
    ssoId: '',
    masterdataCeleraOne: {
        loading: false,
        data: [],
    },
    linkedAccounts: {
        loading: false,
        data: [],
    },
    linkedAccountsSummary: {
        loading: false,
        data: null,
    },
};

const getters = {
    hasError(state) {
        return state.errorMessage.length > 0;
    },
    hasInfo(state) {
        return state.infoMessage.length > 0;
    },
    fullname(state) {
        if (state.masterdataCeleraOne.data) {
            return Util.masterdataToFullName(state.masterdataCeleraOne.data);
        }
        return '-';
    },
    email(state) {
        if (state.masterdataCeleraOne.data) {
            return state.masterdataCeleraOne.data.email;
        }
        return '-';
    },
};

const actions = {
    initState({ commit, dispatch }, ssoId) {
        commit('initState', ssoId);
        dispatch('getLinkedAccounts', ssoId);
        dispatch('getMasterdata', ssoId);
        dispatch('getLinkedAccountsSummary', ssoId);
    },
    getLinkedAccounts({ commit }, ssoId) {
        if (ssoId) {
            commit('setLoading', { key: 'linkedAccounts', loading: true });

            Api.customer.getLinkedAccounts(ssoId).then(({ data }) => {
                commit('setData', { key: 'linkedAccounts', data: data.data });
            }).catch(() => {
                commit('setData', { key: 'linkedAccounts', data: [] });
            }).finally(() => {
                commit('setLoading', { key: 'linkedAccounts', loading: false });
            });
        }
    },
    getMasterdata({ commit }, ssoId) {
        if (ssoId) {
            commit('setLoading', { key: 'masterdataCeleraOne', loading: true });

            Api.customer.detail.masterdataCeleraone(ssoId).then(({ data }) => {
                commit('setData', { key: 'masterdataCeleraOne', data: data.data });
            }).catch(() => {
                commit('setData', { key: 'masterdataCeleraOne', data: null });
            }).finally(() => {
                commit('setLoading', { key: 'masterdataCeleraOne', loading: false });
            });
        }
    },
    getLinkedAccountsSummary({ commit }, ssoId) {
        if (ssoId) {
            commit('setLoading', { key: 'linkedAccountsSummary', loading: true });

            Api.customer.detail.linkedAccountsSummary(ssoId).then(({ data }) => {
                commit('setData', { key: 'linkedAccountsSummary', data: data.data });
            }).catch(() => {
                commit('setData', { key: 'linkedAccountsSummary', data: null });
            }).finally(() => {
                commit('setLoading', { key: 'linkedAccountsSummary', loading: false });
            });
        }
    },
    resetState({ commit }) {
        commit('setLoading', { key: 'masterdataCeleraOne', loading: false });
        commit('setLoading', { key: 'linkedAccounts', loading: false });
        commit('setData', { key: 'masterdataCeleraOne', data: null });
        commit('setData', { key: 'linkedAccounts', data: [] });
        commit('setInfoMessage', '');
        commit('setErrorMessage', '');
        commit('initState', { linkedAccounts: [], ssoId: '' });
    },
};

const mutations = {
    setLoading(state, { key, loading }) {
        Vue.set(state[key], 'loading', loading);
    },

    setData(state, { key, data }) {
        Vue.set(state[key], 'data', data);
    },

    setMasterdataCeleraOne(state, masterdata) {
        state.masterdataCeleraOne = masterdata;
    },

    setErrorMessage(state, message) {
        state.errorMessage = message;
    },

    setInfoMessage(state, message) {
        state.infoMessage = message;
    },

    initState(state, ssoId) {
        state.ssoId = ssoId;
    },

    setLinkedAccounts(state, linkedAccounts) {
        state.linkedAccounts = linkedAccounts;
    },

};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
